module.exports = __webpack_public_path__ + "static/media/banner-collapse-title-background.552effc6.svg";